import React, { Component, Fragment } from "react";
import Moment from "react-moment";

class OrderBox extends Component {
  render() {
    const { order, idx } = this.props;
    
    const reportStatusEnum = {
      '1': '等待付款中',
      '2': '付款完成，商品發送中',
      '3': '付款完成，商品已發送',
      '4': '付款完成，商品已發送',
      '5': '退費申請中',
      '6': '退費完成',
      '8': '付款失敗，訂單已取消',
      '9': '超過付款時間，訂單已取消',
      'M': '付款完成，商品已發送',
      'N': '等待付款中',
      'P': '付款完成，商品發送中',
      'S': '付款完成，商品發送中',
    };

    let icon;
    let realWireTime;
    let TradeNo;
    switch (order.report_status) {
      case '1':
        if (order.TradeNoC) {
          icon = <img src="img/icon_wrong.svg" alt="" />;

          TradeNo = 
          <Fragment>
          <tr>
          <td>藍新交易序號</td>
          <td>{order.TradeNoC}</td>
          </tr>
          <tr>
          <td>銀行代碼</td>
          <td>{order.BankCode}</td>
          </tr>
          <tr>
          <td>轉帳帳號</td>
          <td>{order.CodeNo}</td>
          </tr>
          <tr>
          <td>有效繳費時間</td>
          <td><Moment format="YYYY/MM/DD">{order.ExpireDate}</Moment>{` ${order.ExpireTime}`}</td>
          </tr>
          </Fragment>
          ;
        }
        break;
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case 'M':
      case 'P':
      case 'S':
        realWireTime = <tr>
        <td>付費完成時間</td>
        <td><Moment format="YYYY/MM/DD HH:mm">{order.real_wire_time}</Moment></td>
        </tr>;
        
        if (order.TradeNoR) {
          TradeNo = 
          <tr>
          <td>藍新交易序號</td>
          <td>{order.TradeNoR}</td>
          </tr>;
        }
        break;
      case '8':
        icon = <img src="img/icon_wrong.svg" alt="" />;

        if (order.TradeNoR) {
          TradeNo = 
          <tr>
          <td>藍新交易序號</td>
          <td>{order.TradeNoR}</td>
          </tr>;
        }
        break;
    }


    return (
      <div className="details">
        <p className="btn-order" style={{ height: "90px" }}> <a className="btn" data-bs-toggle="collapse" href={`#collapse_${idx}`} role="button" aria-expanded="false" aria-controls={`collapse_${idx}`}> 
          <span className="t1"><Moment format="YYYY/MM/DD HH:mm">{order.wire_time}</Moment></span><br />
          <span className="t2">{`${order.game_name} ${order.wire_amount}元 `}{icon}</span><span className="open">+</span> </a> </p>
        <div className="collapse" id={`collapse_${idx}`}>
          <table>
            <tbody>
              <tr>
                  <td>訂單號(VIP訂單號)</td>
                  <td>{order.report_id}</td>
              </tr>
              <tr>
                  <td>遊戲名稱</td>
                  <td>{order.game_name}</td>
              </tr>
              <tr>
                  <td>伺服器</td>
                  <td>{order.server_name}</td>
              </tr>
              <tr>
                  <td>角色名稱</td>
                  <td>{order.char_name}</td>
              </tr>
              <tr>
                  <td>角色ID</td>
                  <td>{order.role_id}</td>
              </tr>
              <tr>
                  <td>匯款金額</td>
                  <td>{order.wire_amount}</td>
              </tr>
              <tr>
                  <td>商品</td>
                  <td>{`台幣 ${order.wire_amount} 方案 x ${order.qty}`}</td>
              </tr>
              <tr>
                  <td>訂單狀態</td>
                  <td>{reportStatusEnum[order.report_status]}</td>
              </tr>
              {realWireTime}
              {TradeNo}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default OrderBox;
